import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { HttpService } from 'src/app/services/http.service';

@AutoUnsubscribe()
@Component({
  selector: 'app-cancel-transaction',
  templateUrl: './cancel-transaction.component.html',
  styleUrls: ['./cancel-transaction.component.scss']
})
export class CancelTransactionComponent implements OnInit, OnDestroy {

  constructor(
    private route: ActivatedRoute,
    private http: HttpService
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      if (params) {
        // Cancel Get Request
        this.http.cancelTransaction(params.key);
      }
    });
  }

  ngOnDestroy(): void {

  }

}
